// eslint-disable-next-line
import requirejsModule from 'exports-loader?requirejs,require,define!requirejs/require';
import _ from 'underscore';

// Use default import + runtime property access to avoid webpack 5 dropping
// the "require" named export (webpack treats "require" as a reserved
// identifier and resolves it to undefined in static ES import bindings).
const { require, define } = requirejsModule;

// This is a hack for requirejs to handle "*!*" not as a module loaded by plugin for legacy i18n modules.
// Please keep this list not increased, and no more patch modules should be added to the below map, unless you want to be compatible with some legacy shared components.
const PatchMap = {
  '@bingads-webui/i18n-amd-loader!shared-components/request-call-modal': 'tl-i18n/shared-components/request-call-modal',
  '@bingads-webui/i18n-amd-loader!shared-components/ms-support-chat-modal': 'tl-i18n/shared-components/ms-support-chat-modal',
};

const patchDep = dep => _.get(PatchMap, dep, dep);

const originalRequire = require;

const exportRequire = function (deps, callback, errback, optional) {
  let newDeps = deps;

  if (_.isArray(deps)) {
    newDeps = _.map(deps, patchDep);
  }

  if (_.isString(deps)) {
    newDeps = patchDep(deps);
  }

  return originalRequire(newDeps, callback, errback, optional);
};

Object.keys(originalRequire).forEach((key) => {
  if (Object.prototype.hasOwnProperty.call(originalRequire, key)) {
    exportRequire[key] = originalRequire[key];
  }
});

window.requirejs = exportRequire;
window.require = exportRequire;
window.define = define;

export { exportRequire as requirejs, exportRequire as require, define, originalRequire };
